/* ⚛ REACT */
import React, { useEffect } from "react";

/* 📦 LIBS */
import { useLocation } from "react-router-dom";
import { useTour } from "@reactour/tour";

/* 🧩 COMPONENTS */
import { Button, CloseIcon } from "../../Components";

/* 🧠 REDUX */
import { store } from "../../Redux/Store";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { changeModal } from "../../Redux/Actions";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, ContentContainer, ChildsContainer } from "./styles";

/* 🔧 UTILS */
import { isValidaProp } from "../../util/validate";

const Modal = (props) => {

    const { isOpen, currentStep } = useTour();

    let childs = React.Children.toArray(props.children);
    let active = useSelector(state => state.ModalReducer.name) === props.name;
    const height = isValidaProp(props.height) ? props.height : '50%';
    const width = isValidaProp(props.width) ? props.width : '50%';

    const location = useLocation();

    useEffect(() => {
        store.dispatch(changeModal(null));
    }, [location]);

    return(
        <>
            <Container $Active={active}>
                <ContentContainer $width={width} $height={height} id={props.id}>
                    <Button 
                    color={"white-green"} 
                    onClick={() => store.dispatch(changeModal(null))} 
                    icon={<CloseIcon fill={"#333"} />} 
                    padding={"0"} 
                    position={"absolute"} 
                    radius={"50%"} 
                    height={"44px"} 
                    width={"44px"}
                    disabled={isOpen && (currentStep === 1 || currentStep === 3)}/>

                    {props.title &&
                        <TitleContainer>
                            <Title>{props.title}</Title>
                        </TitleContainer>
                    }
                    <ChildsContainer>
                        {childs.map(child => (
                            child
                        ))}
                    </ChildsContainer>
                </ContentContainer>
            </Container>
        </>
    )
}

export default Modal;